<div class="home-page-wrapper d-none d-lg-block">
  <div class="home-page-head">
    <span class="welcome-title" data-testid="welcome-title">
      Welcome back,&nbsp;
      <strong data-testid="user-name">{{ userObj.firstName + ' ' + userObj.lastName }}</strong>
    </span>
  </div>
  <div class="home-page-content">
    <div
      class="apps-section mb-5"
      *ngIf="userApps.length || isIMSSelected || showConsignment"
      data-testid="apps-section"
    >
      <h6 data-testid="your-apps-title">Your Apps</h6>
      <div class="row apps-wrapper">
        <div
          class="col-md-6 cst-col"
          *ngFor="let item of userApps; trackBy: trackById"
          data-testid="app-card"
        >
          <div
            class="col-wrapper c-pt justify-content-between"
            [ngClass]="{ 'app-disabled': item.isDisabled }"
          >
            <div
              class="d-flex"
              style="flex-basis: 100%; height: 100%; align-items: center"
              (click)="!item.isDisabled && redirectToModule(item.id)"
              (contextmenu)="!item.isDisabled && onRightClick($event, item)"
              [style.cursor]="item.isDisabled ? 'not-allowed' : 'pointer'"
              data-testid="app-main"
            >
              <div class="logo-url">
                <img width="36" [src]="item.appIcon" data-testid="app-logo" />
              </div>
              <h4 class="mb-0 ms-3" style="padding-block: 12px" data-testid="app-name">
                {{ item.name }}
              </h4>
            </div>
          </div>
        </div>
        <div class="col-md-6 cst-col" data-testid="app-card" *ngIf="isIMSSelected">
          <div class="col-wrapper c-pt justify-content-between">
            <div
              class="d-flex"
              style="flex-basis: 100%; height: 100%; align-items: center"
              (click)="redirectToModule(7)"
              (contextmenu)="
                onRightClick($event, { id: 7, name: 'IMS', appIcon: 'assets/images/ims-icon.png' })
              "
              data-testid="app-main"
            >
              <div class="logo-url">
                <img
                  width="36"
                  src="../../../../assets/images/users-management/listerlogo.svg"
                  data-testid="app-logo"
                />
              </div>
              <h4 class="mb-0 ms-3" style="padding-block: 12px" data-testid="app-name">IMS</h4>
            </div>
          </div>
        </div>
        <div class="col-md-6 cst-col" data-testid="app-card" *ngIf="showConsignment">
          <div class="col-wrapper c-pt justify-content-between">
            <div
              class="d-flex"
              style="flex-basis: 100%; height: 100%; align-items: center"
              (click)="redirectToModule(Apps.Consignment)"
              (contextmenu)="
                onRightClick($event, {
                  id: Apps.Consignment,
                  name: 'Consignment',
                  appIcon: 'assets/images/subscription/ConsignmentLogo.png'
                })
              "
              data-testid="app-main"
            >
              <div class="logo-url">
                <img
                  width="36"
                  src="assets/images/subscription/ConsignmentLogo.png"
                  data-testid="app-logo"
                />
              </div>
              <h4 class="mb-0 ms-3" style="padding-block: 12px" data-testid="app-name">
                Consignment
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="apps-section"
      *ngIf="isNotSufficientPermission && !isIMSSelected && !showConsignment"
      data-testid="no-permission-section"
    >
      <div class="alert alert-warning" role="alert" data-testid="no-permission-alert">
        You do not have sufficient permission to access any apps.
      </div>
    </div>
  </div>
</div>
<div
  *ngIf="showContextMenu"
  [ngStyle]="{ top: contextMenuPosition.y, left: contextMenuPosition.x }"
  class="custom-context-menu"
  (click)="openInNewTab()"
  data-testid="context-menu"
>
  Open in new tab
</div>

<!-- Boostrap modal for showing warning -->
<button
  #defaultStoreWarning
  class="d-none"
  data-bs-target="#defaultStoreWarningModal"
  data-bs-toggle="modal"
  data-testid="default-store-warning-btn"
>
  fghfd
</button>
<div
  class="modal fade"
  id="defaultStoreWarningModal"
  aria-hidden="true"
  aria-labelledby="exampleModalToggleLabel"
  tabindex="-1"
  data-bs-backdrop="static"
  data-testid="default-store-warning-modal"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="custom-modal-header modal-header pb-0">
        <h5 class="mb-0" data-testid="default-store-modal-title">Default Store Not Configured!</h5>
      </div>
      <div class="custom-modal-body modal-body">
        <div class="modal-body-wraapper">
          <p style="font-size: 14px" data-testid="default-store-modal-desc">
            The system could not detect a default store assigned to your account ({{
              userObj.firstName + ' ' + userObj.lastName
            }}).
          </p>
          <p style="font-size: 14px">
            Please
            <a
              style="color: blue"
              data-bs-dismiss="modal"
              aria-label="Close"
              (click)="nevigateToDefaultStoreConfig()"
              data-testid="default-store-config-link"
              >click the link above</a
            >
            to configure your default store and proceed.
          </p>
          <p style="font-size: 14px">
            This setup is required to ensure proper access and functionality.
          </p>
        </div>
      </div>
      <div class="custom-modal-footer modal-footer pt-0">
        <button
          class="btn modal-btn"
          style="cursor: pointer"
          data-bs-dismiss="modal"
          aria-label="Close"
          data-testid="default-store-modal-close"
        >
          Close
        </button>
      </div>
    </div>
  </div>
</div>


<div class="mobile-screen d-block d-lg-none">
  <div class="home-page-wrapper">
    <!-- Welcome Header -->
    <div class="home-page-head">
      <span class="welcome-title" data-testid="mobile-welcome-title">
        Welcome back,&nbsp;
        <strong class="user-name" data-testid="mobile-user-name">{{
          userObj.firstName + ' ' + userObj.lastName
        }}</strong>
      </span>
    </div>

    <div class="home-page-content">
      <!-- Apps Section -->
      <div
        class="apps-section mb-5"
        *ngIf="userApps.length || showConsignment"
        data-testid="mobile-apps-section"
      >
        <h6 class="fw-bold mb-3" data-testid="mobile-your-apps-title">Your apps</h6>

        <div class="apps-list">
          <!-- Loop each app -->
          <div
            class="app-card mb-4 p-3 shadow-sm border rounded-4"
            *ngFor="let item of userApps; trackBy: trackById"
            data-testid="mobile-app-card"
            [ngClass]="{ 'app-disabled': item.isDisabled }"
          >
            <!-- App Header -->
            <div
              class="d-flex justify-content-center align-items-center mb-3"
              [class.app-disabled]="item.isDisabled"
              [style.cursor]="item.isDisabled ? 'not-allowed' : 'pointer'"
              (click)="accessListerMobile(item.id)"
            >
              <div
                class="logo-url rounded-circle bg-light d-flex justify-content-center align-items-center"
                style="width: 40px; height: 40px"
              >
                <img width="24" [src]="item.appIcon" data-testid="mobile-app-logo" />
              </div>
              <h6 class="mb-0 ms-2 text-center fw-semibold" data-testid="mobile-app-name">
                {{ item.name }}
              </h6>
            </div>
          </div>
        </div>
        <div
          class="app-card d-flex justify-content-center align-items-center border rounded-4"
          (click)="accessIMS()"
          *ngIf="canShowImsOption"
          data-testid="mobile-ims-access"
        >
          <div class="ims-access d-flex">
            <img src="assets/images/company-management/ims_color_icon.svg" alt="" />
            <a>
              <h6 class="mb-0 ms-2 text-center fw-semibold">IMS</h6>
            </a>
          </div>
        </div>
        <div
          class="app-card d-flex justify-content-center align-items-center border rounded-4"
          (click)="accessConsignment()"
          *ngIf="showConsignment"
          data-testid="mobile-consignment-access"
        >
          <div class="ims-access d-flex">
            <img src="assets/images/subscription/ConsignmentLogo.png" alt="" />
            <a>
              <h6 class="mb-0 ms-2 text-center fw-semibold">Consignment</h6>
            </a>
          </div>
        </div>
      </div>

      <!-- No Permission -->
      <div
        class="apps-section"
        *ngIf="isNotSufficientPermission && !showConsignment"
        data-testid="mobile-no-permission-section"
      >
        <div
          class="alert alert-warning small"
          role="alert"
          data-testid="mobile-no-permission-alert"
        >
          You do not have sufficient permission to access any apps.
        </div>
      </div>
    </div>
  </div>
</div>
